import styled from "styled-components";

export const ContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;

  .page-heading {
    padding: 20px 0;
    box-shadow: unset;
    width: 100%;
  }

  .wrapper-header-content {
    width: 100%;
  }

  .click-blocked {
    pointer-events: none;
  }

  .table-content {
    overflow: auto !important;
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-wrap: wrap;
  .field-holder {
    height: 100%;
  }

  .field-holder .select-field-holder {
    height: 100%;
  }

  input[type="text"] {
    border-radius: 8px !important;
  }

  select {
    border-radius: 8px !important;
    width: 100% !important;
    color: #b1b1b1;
    font-size: 13px;
    padding: 5px 16px;
    height: 100%;
  }

  .select-field-holder .arrow-icon {
    top: 8px;
    font-size: 15px;
    font-weight: 700;
  }

  .date-range,
  .status,
  .partner,
  .per_page {
    height: auto;
    width: 100%;
  }

  .date-range {
    width: 250px;
  }

  .multiple-selection {
    width: 180px;

    .field-holder .input {
      width: 180px;
      border-radius: 8px;

      .react-select__placeholder {
        color: rgba(153, 153, 153, 0.6);
        font-size: 0.9rem;
      }
    }
  }

  .state {
    width: 160px;
    height: 44px;
  }

  button {
    align-self: flex-start;
  }
`;

export const FiltersStyled = styled.div`
  margin-top: 20px;
  width: 100%;

  .select-search-submit {
    input {
      border-radius: 8px;
    }
  }

  .or {
    font-size: 1.5rem;
    line-height: 1rem;
    margin-top: 20px;
  }

  .fast-filtering {
    h1 {
      font-size: 1.2rem;
      line-height: 1rem;
    }

    .total-items {
      margin-left: auto;
      display: block;
      text-align: right;
      white-space: nowrap;
      font-size: 14px;
    }
  }

  .wrapper {
    display: flex;
    justify-content: space-evenly;
    gap: 5px;
    align-items: center;
  }

  .filters {
    width: 100%;
    height: auto;
    border-radius: 50px;
    background: none;
    display: flex;
    text-align: center;
    height: 15px;
    line-height: 15px;
  }
`;

export const TooltipWrapper = styled.div<{ color: string; width: number }>`
  position: relative;
  display: inline-block;
  width: ${({ width }) => `${width ? `${width}%` : "auto"} `};
  background: ${({ color }) => color};
  border-radius: 50px;
  cursor: pointer;

  span {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    // top: 150%;
    left: 50%;
    margin-left: -60px;
  }

  span::after {
    content: "";
    position: absolute;

    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }

  &:hover {
    span {
      visibility: visible;
    }
  }

  button {
    cursor: pointer;
    height: 100%;
    // width: 40px;
    border: none;
    position: relative;
    background: transparent;
    color: white;
    font-weight: 600;
  }
`;

export const SelectAppointment = styled.div`
  width: 100%;

  .text-md {
    font-size: 1.3rem;
  }

  .message-success {
    max-width: 450px;
    margin: 0 auto;
    text-align: center;
  }

  .scheduleinfo {
    font-size: 1rem;
  }
`;

export const TRContent = styled.tr`
  button {
    padding: 0 10px;
  }
`;
